import React from 'react';
import {
  Button, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import {WithTranslation, withTranslation} from 'react-i18next';
import { CommentModel } from '../../api/core/core.types';
import dayjs from 'dayjs';
import { DATE_TIME_FORMAT } from '../../api/api.types';

interface BrokerRateCommentThreadProps extends WithTranslation {
  toggle: () => void;
  isOpen: boolean;
  content?: CommentModel[];
  onClose: () => void;
}

class BrokerRateCommentThreadModal extends React.PureComponent<BrokerRateCommentThreadProps> {

  render() {
    const { t } = this.props;

    return (
      <Modal style={{ minWidth: '500px'}} isOpen={this.props.isOpen} toggle={this.props.toggle} autoFocus={false}>
        <ModalHeader toggle={this.props.toggle}>{t('modal.title.broker_rate_comment')}</ModalHeader>
        <div>
          <ModalBody>
            <div>
              <div className="scrolling-modal-div-large">
                {this.props.content && this.props.content.length > 0 ? (this.props.content.map((comment: CommentModel, index: number) => {
                  return  (<>
                      <div className="col-12 d-flex justify-content-start">
                        <p key={index}>
                            <span
                              className="text-bold"> {comment.createdBy} @ {dayjs(comment.dateCreated, 'YYYY-MM-DD HH:mm:ss').format(DATE_TIME_FORMAT)}:</span>
                          <br/>
                          <pre>{comment.text}</pre>
                        </p>
                      </div>
                    </>
                  );
                })) : ''
                }
              </div>
            </div>
          </ModalBody>
        </div>
        <ModalFooter>
          <Button color="primary" onClick={this.props.onClose}>{t('b.close').toUpperCase()}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withTranslation()(BrokerRateCommentThreadModal);
